<div class="page">
  <kgrid
    #grid
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    reportName="Item"
    [unSortableFilterable]="unSortableFilterable"
    pathPreFix="SALE"
    defaultSortKey="Code"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [IgnoreDeletePermission]="IgnoreDelete"
    [deleteMessage]="deleteMessage"
    [actions]="actions"
    [actionTregger]="onActionClick.bind(this)"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isDelete]="isDelete"
    [customExportExcelUrl]="'Item/ExportExcel'"
    [getParamsForExportExcelWithPostMethod]="getParamsForExportExcelWithPostMethod.bind(this)">
  </kgrid>
</div>
